import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'contexts/auth-context';
import { NotificationProvider } from 'contexts/notification-context';
import { Routes } from "components/Routes";

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <NotificationProvider>
                    <Routes />
                </NotificationProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
